import React from 'react';

import PropTypes from 'prop-types';

import ManageProduct from '../ManageProduct/ManageProduct';

export default function EditProduct({
  match: {
    params: { id },
  },
}) {
  return <ManageProduct id={id} title="Edit product" />;
}

EditProduct.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  }).isRequired,
};
